// PaymentTransparency.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const PaymentTransparency = () => {
  const terms = [
    'All fees are communicated clearly before payment',
    'No hidden or surprise charges',
    'Payments are made only after consultation and agreement',
    'Receipts and documentation are provided'
  ];

  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
              Payments and Terms
            </h2>
          </motion.div>

          {/* Payment Transparency Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-8 rounded-lg shadow-sm"
          >
            <h3 className="text-xl font-semibold text-[#202356] mb-6">
              Payment Transparency
            </h3>

            {/* Terms List */}
            <div className="space-y-4 mb-6">
              {terms.map((term, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle2 size={18} className="text-gray-700 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 text-base font-light">
                    {term}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Bottom Note */}
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              Payment methods, timelines, and instalment options, if available, are discussed during onboarding.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PaymentTransparency;
